module.exports = "/_next/static/images/dcba1407c5a49be0206ebd68517bf54c-question.svg.webp";